import { Checkbox } from 'antd';
import { useEffect, useState } from 'react';
import { Button } from 'antd';
import { Gallery } from 'react-grid-gallery';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css';
import { Colors } from '../../../config/theme';
import ShowImage from '../../../components/show_image';
import Wrapper from '../image_library_page.styled';
import { ImageType } from '../../../data/types/files';
import { Pagination } from '@nextui-org/react';
import { Icon } from '@iconify/react';

type ImagesGalleryProps = {
  alts_modal: boolean;
  images: ImageType[];
  setEditableImages: (images: ImageType[]) => void;
  done: boolean;
  search: string;
  loadMore: () => void;
  total: number;
  inCreateListing?: boolean;
  ownedLibrary: boolean;
  checkedImagesIds?: Set<number>;
};

type ImageTypeWithChecked = ImageType & {
  check: boolean;
};

export function ImagesGallery({
  alts_modal,
  images,
  setEditableImages,
  done,
  search,
  loadMore,
  total,
  inCreateListing,
  ownedLibrary,
  checkedImagesIds,
}: ImagesGalleryProps) {
  const [libraryImages, setLibraryImages] = useState<ImageTypeWithChecked[]>(
    [],
  );
  const [checkImagesIds, setCheckImagesIds] = useState<Set<number>>(
    checkedImagesIds || new Set<number>(),
  );
  const [index, setIndex] = useState(-1);
  const currentImage = libraryImages[index];
  const nextIndex = (index + 1) % libraryImages.length;
  const nextImage = libraryImages[nextIndex] || currentImage;
  const prevIndex = (index + libraryImages.length - 1) % libraryImages.length;
  const prevImage = libraryImages[prevIndex] || currentImage;
  const handleClick = (index: number) => setIndex(index);
  const handleClose = () => setIndex(-1);
  const handleMovePrev = () => setIndex(prevIndex);
  const handleMoveNext = () => setIndex(nextIndex);

  const [, setShowLightBox] = useState(false);

  const handleChange = (index: number) => {
    libraryImages[index].check = !libraryImages[index].check;
    if (libraryImages[index].check) {
      setCheckImagesIds(checkImagesIds.add(libraryImages[index].id));
    } else {
      setCheckImagesIds(
        new Set(
          Array.from(checkImagesIds).filter(
            (id) => id !== libraryImages[index].id,
          ),
        ),
      );
    }
    setLibraryImages(libraryImages.filter((i: ImageTypeWithChecked) => i));
  };

  useEffect(() => {
    setLibraryImages(images.map((i: ImageType) => ({ ...i, check: false })));
  }, [images]);

  const styling = {
    position: 'relative',
    borderRadius: '12px',
    background: 'white',
    backgroundColor: 'white',
    border: '2px solid transparent',
  };
  const checkedStyling = {
    position: 'relative',
    backgroundColor: 'white',
    background: 'white',
    borderRadius: '12px',
    border: '2px solid ' + Colors.greenMain,
  };

  useEffect(() => {
    setEditableImages(
      libraryImages.filter((i: ImageTypeWithChecked) => i.check),
    );
  }, [libraryImages]);

  useEffect(() => {
    setLibraryImages(
      libraryImages.map((i: ImageTypeWithChecked) => {
        i.check = false;
        return i;
      }),
    );
  }, [done]);

  useEffect(() => {
    filteredImages();
  }, [images, alts_modal, search]);

  const filteredImages = () => {
    let results: ImageType[] = [];
    if (search !== '') {
      results = images.filter((img: ImageType) => {
        if (img?.alt?.toLowerCase().match(search.toLowerCase())) {
          return img;
        }
        return null;
      });
    } else {
      results = images;
    }

    results = results.filter((libraryImageObj: ImageType) => {
      if (alts_modal) {
        if (libraryImageObj.alt === undefined) {
          return libraryImageObj;
        }
      } else {
        return libraryImageObj;
      }
      return null;
    });
    setLibraryImages(
      results.map((i: ImageType) => ({
        ...i,
        check: checkImagesIds.has(i.id),
      })),
    );
  };

  const openLightBox = (index: number) => {
    //TODO
    handleClick(index);
    setShowLightBox(true);
  };

  const handleSelect = (index: number) => {
    handleChange(index);
    setLibraryImages(
      libraryImages.map((image: ImageTypeWithChecked, i: number) =>
        i === index ? { ...image, isSelected: !image.check } : image,
      ),
    );
    setTimeout(() => {
      setShowLightBox(false);
    }, 500);
  };

  const ImageComponent = (props: any) => {
    return (
      <div
        style={
          libraryImages[props.index].check !== true
            ? { ...styling, position: 'relative' } // Include 'position' property
            : { ...checkedStyling, position: 'relative' } // Include 'position' property
        }
      >
        <div
          style={{
            position: 'absolute',
            width: '100%',
            borderRadius: '12px',
            background: 'transparent',
            paddingLeft: '8px',
            paddingRight: '8px',
            paddingTop: '8px',
          }}
          className={
            props.item.alt === null || props.item.alt === undefined
              ? 'alts-Box'
              : 'alts-Boxs'
          }
        >
          {(props.item.alt === null || props.item.alt === undefined) && (
            <div className="alts-logos">
              <Icon
                icon="material-symbols-light:warning-outline"
                width="30"
                height="30"
                style={{ color: 'orange' }}
              />
            </div>
          )}
          {ownedLibrary && (
            <Checkbox
              checked={props.item.check || checkImagesIds.has(props.item.id)}
              onChange={() => handleChange(props.index)}
            />
          )}
        </div>
        <ShowImage
          image={props.item}
          onClick={() => {
            if (inCreateListing) {
              handleChange(props.index);
              return;
            }
            openLightBox(props.index);
          }}
          style={{
            padding: '8px',
            height: '200px',
          }}
        />
      </div>
    );
  };
  return (
    <>
      <Wrapper>
        {libraryImages.length === 0 ? (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
              width: '100%',
            }}
          >
            <br />
            <img
              src={'../../../src/assets/images/illustrations/not-found-box.svg'}
            />
            <br />
            <h6>No more images found</h6>
            {images.length >= total ? null : (
              <Button
                color="primary"
                variant="solid"
                size="large"
                shape="round"
                onClick={loadMore}
              >
                Load More
              </Button>
            )}
          </div>
        ) : (
          <Gallery
            images={libraryImages as any}
            thumbnailImageComponent={ImageComponent}
            onSelect={handleSelect}
            enableImageSelection={true}
            tileViewportStyle={{
              borderRadius: '12px',
              minHeight: '150px',
            }}
            margin={6}
          />
        )}
        {currentImage && (
          <Lightbox
            mainSrc={
              currentImage.public_s3_url ||
              currentImage.get_object_presigned_url
            }
            imageTitle={
              `# ${currentImage.id} ` + (currentImage.alt || 'No Alt Text')
            }
            mainSrcThumbnail={
              currentImage.public_s3_url ||
              currentImage.get_object_presigned_url
            }
            nextSrc={
              nextImage.public_s3_url || nextImage.get_object_presigned_url
            }
            nextSrcThumbnail={nextImage.alt}
            prevSrc={
              prevImage.public_s3_url || prevImage.get_object_presigned_url
            }
            prevSrcThumbnail={prevImage.alt}
            onCloseRequest={handleClose}
            onMovePrevRequest={handleMovePrev}
            onMoveNextRequest={handleMoveNext}
          />
        )}
        <div className="grid-row" />
        {images.length >= total || libraryImages.length === 0 ? null : (
          <div className="row">
            <div style={{ textAlign: 'center' }}>
              <Button
                color="primary"
                variant="solid"
                size="large"
                shape="round"
                onClick={loadMore}
              >
                Load More
              </Button>
            </div>
          </div>
        )}
      </Wrapper>
    </>
  );
}
